module.exports = __webpack_public_path__ + "static/media/icono-usuario-blanco.7f281917.svg";